export const applySwitchAnimation = () => {
    const switchContainer = document.querySelector("#switch_container");
    const switchC1 = document.querySelector("#switch_c1");
    const switchC2 = document.querySelector("#switch_c2");
    const switchCircle = document.querySelectorAll(".switch__circle");
    const signinContainer = document.querySelector(".right__init_switch");
    const signupContainer = document.querySelector(".left__post_switch");
    switchContainer.classList.add("is-gx");
    setTimeout(function () {
        switchContainer.classList.remove("is-gx");
    }, 1500)
    switchContainer.classList.toggle("is-txr");
    switchCircle[0].classList.toggle("is-txr");
    switchCircle[1].classList.toggle("is-txr");
    switchC1.classList.toggle("is-hidden");
    switchC2.classList.toggle("is-hidden");
    signinContainer.classList.toggle("is-txl");
    signupContainer.classList.toggle("is-txl");
    signupContainer.classList.toggle("is-z200");
    const allButtons = document.querySelectorAll(".submit");
    const preventDefault = (e) => e.preventDefault()
    const applySwitch = (e) => {
        for (let i = 0; i < allButtons.length; i++)
            allButtons[i].addEventListener("click", preventDefault);
    }
    window.addEventListener("load", applySwitch);
};
